import React, { Component } from 'react'
import { Input, Radio, Form, Modal } from 'antd'
import InputMask from 'react-input-mask'

const FormItem = Form.Item

class OrganizationCompanyQuickAdd extends Component {
  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.handleQuickAddOrganization(values)
      form.resetFields()
      this.props.handleCancel()
    })
  }

  handleCancel = () => {
    const form = this.props.form
    this.props.handleCancel()
    form.resetFields()
  }

  render() {
    const { getFieldDecorator } = this.props.form
    return (
      <div>
        <Modal
          visible={this.props.modalVisible}
          title="Quick Add Company/Vendor"
          okText={'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={600}
          maskClosable={false}
        >
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Company Name">
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Name cannot be blank.'
                    }
                  ],
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Type">
                {getFieldDecorator('type', {
                  initialValue: this.props.organizartionType
                })(
                  <Radio.Group disabled={this.props.organizartionType ? true : false}>
                    <Radio.Button value="Client">Client</Radio.Button>
                    <Radio.Button value="Vendor">Vendor</Radio.Button>
                  </Radio.Group>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Phone Number">
                {getFieldDecorator('work_number', {
                  initialValue: ''
                })(<InputMask className="ant-input" mask="(999) 999-9999 ext:9999" maskChar="_" />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Mobile Number">
                {getFieldDecorator('fax_number', {
                  initialValue: ''
                })(<Input placeholder="Type in mobile number..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Street Address">
                {getFieldDecorator('address1', {
                  rules: [
                    {
                      required: true,
                      message: 'Street Address cannot be blank.'
                    }
                  ],
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Apt/Suite/Floor">
                {getFieldDecorator('address2', {
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="City">
                {getFieldDecorator('city', {
                  rules: [
                    {
                      required: true,
                      message: 'City cannot be blank.'
                    }
                  ],
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="State">
                {getFieldDecorator('state', {
                  rules: [
                    {
                      required: true,
                      message: 'State cannot be blank.'
                    }
                  ],
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Zip">
                {getFieldDecorator('zip', {
                  initialValue: ''
                })(<Input />)}
              </FormItem>
            </div>
            <div className="col-md-6" />
          </div>
        </Modal>
      </div>
    )
  }
}

export default Form.create()(OrganizationCompanyQuickAdd)



// WEBPACK FOOTER //
// ./src/components/organization/OrganizationQuickAdd.js